import { nodeListToArray } from '../helpers/nodeListToArray';

export function fiftyFiftyChecker() {
    let rowElements = nodeListToArray(document.querySelectorAll('.row')) as HTMLElement[];

    if (rowElements.length > 0) {

        for (let rowElement of rowElements) {

            let childElements = [].slice.call(rowElement.children) as HTMLElement[];
            let elementsWithFiftyFifty = childElements.filter(el => el.classList.contains('fiftyfiftyblock'));


            if (elementsWithFiftyFifty.length > 0 ) {
                rowElement.classList.add('fiftyfifty-row');
            }


        }
    }
}